import React from 'react'
import { Link } from 'react-router-dom'

interface IProps {
  to: string
  name: string
  description?: string
  imageLink?: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

const NewInstagramBotCard: React.FC<IProps> = ({ to, name, description, imageLink, onClick }) => {
  return (
    <Link
      to={to}
      role='button'
      className='card h-100'
      style={{
        cursor: 'pointer',
        backgroundColor: '#FFFFFF',
        border: '1px solid rgba(138, 63, 252, 0.1)',
        borderRadius: '1.25rem',
        boxShadow: '9px 8px 7px rgba(138, 63, 252, 0.1)',
        transition: 'transform 0.2s ease-in-out',
        overflow: 'hidden'
      }}
      onMouseOver={(e) => (e.currentTarget.style.transform = 'translateY(-5px)')}
      onMouseOut={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
      onClick={onClick}
    >
      <div className='p-3'>
        <img
          src={imageLink}
          className='card-img-top'
          alt={name}
          style={{
            borderRadius: '1rem',
            objectFit: 'cover',
            aspectRatio: '16/11'
          }}
        />
      </div>
      <div className='card-body pt-0 px-4 pb-4'>
        <h5 className='card-title fw-bolder text-dark mb-2'>{name}</h5>
        <p className='card-text text-muted fs-7'>
          {/* Cleaned up description to match the UI */}
          {description}
        </p>
      </div>
    </Link>
  )
}

export default NewInstagramBotCard
